import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const BoTimelineService = {
    apply: async (dataId) => axios.post(`${API_URL}/bo_timeline/apply`, dataId).then(({ data }) => data.data).catch(err => {throw err;})
};

export default BoTimelineService;